<template>
  <div
    class="wysiwyg-content"
    v-html="sanitizedContent"
  />
</template>

<script>
export default {
  props: {
    'widget': {
      type: Object,
      required: true
    }
  },
  computed: {
    sanitizedContent() {
      // This removes the target attribute from the Quill-generated links
      const content = this.widget.widgetSettings.wysiwygContent
      return content.replace(/target="_blank"/g, '')
    }
  }
}
</script>
<style lang="scss">

.wysiwyg-content {
//indentation
//for each indentation step we increase the margin
$for-class: ql-indent !default;
@for $i from 1 through 8 {
    .#{$for-class}-#{$i} {
      margin-left: .5rem + $i*1.5;
  }
}

//video
.ql-video {
  width: 100%;
  height: 56.25%;
}
//alignment
  .ql-align-right {
    text-align: right;
  }
  .ql-align-center {
    text-align: center;
  }
  .ql-align-justify {
    text-align: justify;
  }
//code
  pre {
    color: inherit;
  }
//base typography spacing
  ol,
  ul {
    padding-left: 1.5rem;
    margin-bottom: 1rem;
  }
  ul {
    list-style: disc;
    list-style-position: outside;
  }
  //blockquote
  blockquote {
    border-left: 2px solid;
    border-color: inherit;
    padding-left: 1.5rem;
    font-style: italic;
  }
}

</style>
